/*
 * @Author: cheesekun
 * @Date: 2021-04-07 15:41:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-08 10:35:03
 * @FilePath: \dc-vizier-tpl-h5\src\api\index.js
 */
import http from '@/utils/request'

// 获取actID
// export function getActInfo () {
//   return http.get('/wsynq/activity_info')
// }

export function getInformationCenterList (param) {
  return http.post('/api/frontend/info/get_list', param)
}

export function getInformationContent (param) {
  return http.post('/api/frontend/info/get_content', param)
}
